import { Nullable } from 'common/types';

export const SET_MAINTENANCE_MESSAGE = 'SET_MAINTENANCE_MESSAGE';

export interface MaintenanceMessageState {
  message: Nullable<string>;
  lastUpdated: Nullable<number>;
}

export interface SetMaintenanceMessageType {
  type: typeof SET_MAINTENANCE_MESSAGE;
  message: string;
}

export type MaintenanceMessageTypes = SetMaintenanceMessageType;
